// extracted by mini-css-extract-plugin
export default {"color_red_2":"var(--color-red-2)","color_green":"var(--color-green)","color_yellow_2":"var(--color-yellow-2)"};